<div class="modal-header">
  <button type="button" class="btn-close" (click)="bsModalRef.hide()" [attr.aria-label]="'button.close' | translate"></button>
</div>
<div class="modal-body">
  <p>
    {{ 'hint.forgot-password-email.' + tenant | translate }}
  </p>

  <app-form-field-text
    [field]="emailControl"
   
    label="label.email"
  ></app-form-field-text>
</div>
<div class="modal-footer">
  <button
    class="btn btn-primary"
    (click)="submit()"
  >
    {{ 'label.reset-password' | translate }}
  </button>
</div>
